import { render, staticRenderFns } from "./performanceStatistics.vue?vue&type=template&id=3fa402ee&scoped=true"
import script from "./performanceStatistics.vue?vue&type=script&lang=js"
export * from "./performanceStatistics.vue?vue&type=script&lang=js"
import style0 from "./performanceStatistics.vue?vue&type=style&index=0&id=3fa402ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa402ee",
  null
  
)

export default component.exports